export enum CalcConstants {
  delete = "delete",
  dropdownMultiple = "dropdown-multiple",
  low = "Low",
  high = "High",
}
